export enum DateGroupTypeEnum {
    WEEK = "week_of_year",
    MONTH = "month",
}
